import './index.css';

export default {
  name: 'Atransfer',
  props: {
    list: {
      type: Array,
      default: () => [
        { key: 0, label: '备选项1' },
        { key: 1, label: '备选项2' },
        { key: 2, label: '备选项3' },
        { key: 3, label: '备选项4' },
        { key: 4, label: '备选项5' },
        { key: 5, label: '备选项6' },
        { key: 6, label: '备选项7' },
        { key: 7, label: '备选项8' },
        { key: 8, label: '备选项9' },
        { key: 9, label: '备选项10' },
      ]
    },
    data: { type: Array, default: () => [1, 4] },
    filterable: { type: Boolean, default: () => true },
  },
  data() {
    return {
      value: [],
    };
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      this.value = this.data;
    },
    format(h, { key, label }) {
      return (
        <div class="a-transfer-rows">
          <div>{key}</div>
          <div>{label}</div>
        </div>
      );
    },
  },
  render() {
    const { ...attrs } = this.$attrs;
    return (
      <div class="a-transfer">
        <el-transfer
          v-model={this.value}
          data={this.list}
          filterable={this.filterable}
          render-content={this.format}
          {...{ attrs }}
        />
      </div>
    );
  }
};